module.exports = "//static.hsappstatic.net/marketplace-assets-base/static-1.3486/img/business-types/marketing.png"